/**
 * Filtra módulos de Intro/header por permiso (ngx-permissions).
 * Usa `.filter` (no `forEach`+`splice`) para no saltar entradas al mutar el array.
 */
export function filterModulesByAnyPermission<T extends { permissions?: string[] }>(
	modules: T[],
	hasPermission: (permission: string) => unknown
): T[] {
	return (modules || []).filter((module) =>
		(module.permissions || []).some((permission) => !!hasPermission(permission))
	);
}
